import React, {Component} from "react" ;
import "../../helper/explorer_support";

class Body extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isMobile : window.innerWidth > 991 ? false : true
		}
	}
	render() {
		const {isMobile} = this.state;
		return (
			<tbody>
			{
				this.props.items.length === 0 ?
					<tr>
						<td colSpan={this.props.columns.length}>
							{this.props.emptyMessage}
						</td>
					</tr> :
					this.props.items.map((item, i) =>
						<tr key={i+"_upper"} style={this.props.getTrStyles !== undefined ? this.props.getTrStyles(item,i) : {}} className={this.props.getTrClass !== undefined ? this.props.getTrClass(item) : {}}>
							{this.props.columns.map((column, j) =>
								typeof column.accessor === "string" ? (column.Cell === undefined ?
										<td key={j+"_inner"} style={column.getTdStyles && column.getTdStyles(item)} data-label={column.Header}>{!isMobile ? item[column.accessor] :
											item[column.accessor] ? item[column.accessor] : "-" }</td> :
										<td key={j+"_inner"} style={column.getTdStyles && column.getTdStyles(item)} data-label={column.title ? column.title : ""}>{column.Cell(item, i)}</td>
								) : (<td key={j+"_inner"} style={column.getTdStyles && column.getTdStyles(item)} data-label={column.title ? column.title : ""}>
										{
											(column.Cell === undefined ?
													column.accessor.map((data, k) =>
														<p key={k+"_inner2"}>{item[data.accessor] + (k + 1 < column.accessor.length ? "-" : "")}</p>
													) :
													column.Cell(item, i)
											)
										}
									</td>
								))
							}
						</tr>
					)
			}
			</tbody>
		);
	}
}

export default Body;